type Props = {
  text: string;
};

const Error = ({ text }: Props) => (
  <span className="text-xs text-red-500">{text}</span>
);

export default Error;
